import { Div, Mark, Span, ElementRenderer, P, A, Label } from 'alkali'
import { liveParsed, liveQuestion, isEntryPage } from 'model/SearchQuery'
import { questionToText } from 'analysis/Question'
import {
	Toast,
	getToastPosition,
} from 'components/generic/Toast'
import { isAbsolute } from 'path'
import { Chat } from 'integrations/intercom'

export const stringList = (wordList) => {
	let updatedList = []
	const lastTerm = wordList.pop()
	const boldTerms = wordList.map((term) => {
		updatedList.push(Span('.strong', [`${term}, `]))
	});

	const endPhrase = [Span('.normal', [' and ']), Span('.strong', [lastTerm ]), Span('.normal', [' did not match to any known terms in our ontology.'])]
	updatedList = updatedList.concat(endPhrase)
	return updatedList
}

const TypoMessage = (unrecognizedWords) => {
	switch (unrecognizedWords.length) {
		case 1:
			return P([Span('.strong', [unrecognizedWords]), ' did not match to any known terms in our ontology.'])
		case 2:
			return P([
				Span('.strong', [unrecognizedWords[0]]),
				Span('.normal', [' and ']),
				Span('.strong', [unrecognizedWords[1]]),
				Span('.normal', [' did not match to any known terms terms in our ontology.']),
			])
		default:
			return P(stringList(unrecognizedWords))
	}
}

const TypoToast = (typoMessage, toastPosition) =>
	new Toast('#typo-toast.top-arrow', {
		id: 'typo-toast',
		title: typoMessage.length === 1 ? 'Unrecognized Term' : 'Unrecognized Term',
		style: { position: 'absolute', left: toastPosition.x, top: toastPosition.y },
		message: Div([
			typoMessage,
			P([
				'Please check the spelling or consult with the Doctor Evidence team via', A({content: 'Live Chat', onclick: Chat.toggle})
			]),
		]),
		hoverClose: true
	})
// For calculating the top position for toast, we add the 8px so the top arrow sits slightly into the questionbar so we calculate where the toast lies and then push down a bit further for the top arrow.
const displayTypoToast = (inputElement, message) => {
	const toastAlreadyDisplayed = document.getElementById('typo-toast')
	setTimeout(() => {
		if (!toastAlreadyDisplayed) {
			const elementData = getToastPosition(inputElement)
			const toastPosition = !isEntryPage ? {
				x: `calc(${elementData.position.vwPercent} - 5px)`,
				y: `calc(${elementData.position.vhPercent} + ${elementData.position.responsiveHeight} + 16px)`
			} : {
				x: elementData.position.vwPercent,
				y: `calc(${elementData.position.vhPercent} + ${elementData.position.responsiveHeight})`
			}
			message = TypoMessage(message)
			const appendTypoToast = TypoToast(message, toastPosition)
			const resultBody = document.querySelector('#main')
			resultBody.prepend(appendTypoToast)
		}
	}, 200)
}

export const renderQuestion = (question, position?) => {
	let renderedChars = 0
	let focusNode, focusStart, focusEnd
	let rendered = question.map((phrase) => {
		let type = phrase.type
		let content: string
		let hasTerm = phrase.id && (phrase.ids || [phrase.id]).some((id) => /^S[UG0-9]/.test(id))
		let node =
			typeof phrase == 'string'
				? document.createTextNode((content = phrase))
				: new Mark(
						(phrase.placeholder
							? '.annotation-placeholder.annotated-'
							: hasTerm
							? '.annotated-'
							: phrase.unknown
							? '.annotated-unknown.annotated-'
							: '.annotated-no-term.annotated-') + (type || 'unknown'),
						{
							content: [ 
								Label(type),
								(content = phrase.label || type)],
							title: phrase.placeholder
								? 'Enter a ' + type
								: phrase.contains
								? phrase.label +
								  ': ' +
								  phrase.contains.map((sub) => sub.label || sub).join(', ')
								: phrase.originalLabel
								? phrase.label + ': ' + phrase.originalLabel
								: phrase.id
								? (phrase.definition || content || '') +
								  ' (' +
								  fixCase(type) +
								  ')' +
								  (hasTerm
										? ''
										: '. This term does not exist in known medical dictionaries, but exists and can be searched in studies.')
								: 'This term is not in any known medical dictionaries or studies and may be a misspelling',
						}
				  )
		if (!focusNode && type && !phrase.label) {
			focusNode = node
			focusStart = 0
			focusEnd = content.length
		} else if (
			!focusNode &&
			renderedChars < position &&
			renderedChars + content.length >= position
		) {
			focusNode = node
			focusStart = focusEnd = position - renderedChars
		}
		renderedChars += content.length
		return node
	})
	if (!focusNode) {
		focusNode = rendered[rendered.length - 1]
		focusStart = 0
		focusEnd = 0
	}
	rendered.focusNode = focusNode
	rendered.focusStart = focusStart
	rendered.focusEnd = focusEnd
	return rendered
}
const removeMarkWords = ['intervention','condition', 'outcome'].join("|")
export function renderCurrentQuestionInto(element, callback) {
	return new ElementRenderer({
		element,
		variable: liveParsed,
		renderUpdate(question) {
			let rendered =  renderQuestion(question.annotations, liveQuestion.position.valueOf())
			callback(question)
			element.innerHTML = ''
			element.append(...rendered)
			let append = true
			let typoWords = []
			let header = document.querySelector('.header')
			let errorCount = 0
			let termCount = 0
			rendered.find((element, index) => {
				if (element.className) {
					if (element.className.includes('annotated')) {
						termCount++
					}
					if (element.className.includes('annotated-unknown')) {
						errorCount++
					}
				}
			})
			if (errorCount) {
				rendered.find((element, index) => {
					if (typeof question.annotations[index] == 'object') {
						// This was causing typo toast to not work on landing page - not sure if we still want it
						// if (!question.annotations[index].id && !question.annotations[index].placeholder) {
							let typoWord = (element.textContent).replace(new RegExp(removeMarkWords, 'gi'), '').trim().replace(/ +/g, ' ')
							typoWords.push(typoWord)
							element.classList.add('error-text')
							setTimeout(() => {
								element.classList.remove('error-text')
							}, 3000)
						// }
					}
				})
				let bar = window.location.search ? document.querySelector('.question-bar') : document.getElementById('landing-questionbar')
				if (!header.querySelector('.typo-notification-box')) {
					(typoWords.length > 0) ? displayTypoToast(bar, typoWords) : null
				}
			}
		},
	})
}
const fixCase = (word) => (word[0]?.toUpperCase() || '') + word.slice(1)
